import { Outlet } from 'react-router-dom';

import { CartDrawer } from '@/features/cart';
import { Footer } from '@/features/storefront/components/Footer';
import { Navbar } from '@/features/storefront/components/Navbar';
import { useCatalogVersion } from '@/features/storefront/hooks/useCatalogVersion';

/**
 * Chrome for the public storefront: sticky Navbar, routed page, Footer.
 * Light-first — does not depend on the dark theme tokens.
 */
export function StoreLayout() {
  // Storefront only: admin screens use AdminLayout and must not poll.
  useCatalogVersion();

  return (
    <div className="flex min-h-screen flex-col bg-white text-[color:var(--color-body)]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
